<template >
<div class="hello">
    <Menu></Menu>
    <div class="loader-layer" v-show="is_loader">
        <div class="loader"></div>
    </div>
    <div class="class">
        <div class="top wrap clear">
            <h2 class="bold  float-left">Writing {{writing_num}}차 첨삭과제 수정</h2>
        </div>
     
        <div class="page-top-wrap-notice">
            <div class="notice-wrap">
               <div class="add-box clear">
               
                <div class="float-left w-25per  txt-left pl-20 reason-box-title">제출방법<span class="col-red">*</span></div>
                <div class="float-left w-75per pr-20">
                    <label class="mr-10"><input type="radio" name="reason" v-model="gubun" value="file" @change="gubunChange($event)"/>&nbsp;파일첨부</label>
                    <label class="mr-10"><input type="radio" name="reason" v-model="gubun" value="board" @change="gubunChange($event)"/>&nbsp;지금 바로 쓰기</label>

                </div>
               </div>
               <!-- <div class="add-box">
                   <input type="text" placeholder="제목을 입력해 주세요." />
                   <img src="../assets/img/file-icon.png" class="file" />
                   <input type="file"  id="noticeFile" name="noticeFile" style="display:none" accept=".jpg, .png, .doc,.docx, .hwp, .pdf, .ppt, .pptx, .xls, .xlsx" multiple/>
               </div>
               <div class="add-box" >
                   <a href="#"  ><img src="../assets/img/file-download.png" class="mr-10 down-img" /><span  style="color :red; cursor:pointer" class="ml-20">x</span></a><br >
                   <a href="#"  ><img src="../assets/img/file-download.png" class="mr-10 down-img" /><span style="color :red; cursor:pointer" class="ml-20">x</span></a><br >
                   <a href="#" ><img src="../assets/img/file-download.png" class="mr-10 down-img" /><span  style="color :red; cursor:pointer" class="ml-20">x</span></a>
               </div>
               <div class="add-box">
                   <textarea placeholder="내용을 입력해 주세요"></textarea>
               </div> -->
              
        
          
            <div class="add-box clear">
                <div class="clear reason-box" v-if="gubun=='file'">
                    <div class="float-left w-25per  txt-left pl-20 reason-box-title" >파일 업로드<span class="col-red">*</span></div>
                    <div class="float-left w-75per pr-20">
                    <input type="file" name="writingFile" id="writingFile" accept=".pdf, .pptx, .doc, .docx, .xlsx, .hwp" @change="inputName($event)" hidden >
                    <input class="input iblock vb w300" v-model="writing_file_name" readonly/>
                        <button class="btn_base" @click="inputFile($event)">업로드</button>
                    <p class="col-red"> * 1MB 이하 pdf, pptx, doc, docx, xlsx, hwp</p>
                    </div>
                </div>
                <div class="clear reason-box" v-else>
                    <div class="float-left w-25per  txt-left pl-20 reason-box-title">내용<span class="col-red">*</span></div>
                    <div class="float-left w-75per pr-20">
                    <textarea cols="80" rows="30" v-model="writing_content"></textarea>
                    </div>
                </div>
            </div>
         
            </div>
        </div>
        <div class="wrap pt-20">
            <button class="btn-base float-right" @click="submit();" >수정하기</button>
        </div>
    </div>
    <!-- 푸터 -->
    <div class="footer clear">
        Copyright© <span class="bold">CARROT</span> Global Inc. All rights reserved.<br>
    </div>
    
</div>
</template>

<script>
import Menu from '../components/inc_menu.vue'
// import TutorModal from '../components/pop_tutor.vue'
// import ManagerModal from '../components/pop_manager.vue'
// import WtGuideModal from '../components/pop_wtguide_email.vue'
// import EvReport from '../components/inc_ev_report.vue'
export default {
    name: 'WritingMod',
    components: {
        Menu,    
    },
    props: {
        msg: String
    },
    created() {
        if(location.hostname == "stagest.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
        }else if(location.hostname == "st.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "student.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.hostname == "m.carrotenglish.net"){
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }else if(location.href.includes("how")){
            if(location.href.includes("stage")){
                this.$store.commit('changeHost', "https://stagestapi.carrotenglish.net");
            }else{
                this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
            }
        }else{
            this.$store.commit('changeHost', "https://stapi.carrotenglish.net");
        }
        this.$store.commit("loginCheck");

    },
    data: () => ({
        is_loader: true,
        gubun:'file',
        classid:0,
        writing_idx:0,
        writing_content:'',
        writing_num:'',
        writing_file_name:'',
    }),
    mounted() {
    
        this.classid = this.$route.query.classid;
        this.writing_idx = this.$route.query.writing_idx;
        this.writing_num = this.$route.query.writing_num;
        this.getWritingInfo();
    },
    methods: {
        gubunChange: function(e) {
            console.log(e.target.value);
        },
        getWritingInfo: function() {

            var me = this;
            var uidx = localStorage.uidx;
            var formData = new FormData();
            console.log(me.$route.query.classid);
            formData.append('uidx',uidx);
            formData.append('classid',me.$route.query.classid);
            formData.append('writing_idx',me.$route.query.writing_idx);

            this.axios.post(this.$store.state.host + '/rest/writing/getWritingUserInfo', formData).then(function (res) {                
                console.log(res);
                if(res.data.err ==0) {
                    if(res.data.info.correction_text !='' && res.data.info.correction_text != null) {
                        
                        me.writing_content = res.data.info.correction_text; 
                        me.gubun = 'board';
                    } else {
                       
                        var url_arr = res.data.info.url_writing.split('/');
                        var file_name = url_arr[url_arr.length-1];
                        me.writing_file_name = file_name;
                        // var wfile = document.getElementById('#writingFile');                    
                        
               
                        me.gubun = 'file';
                    }
                }
            });

            
        },        
        submit: function() {
            var me = this;
            var uidx = localStorage.uidx;
            var formData = new FormData();

            formData.append("uidx", uidx);
            formData.append("gubun", me.gubun);
            formData.append("idx_itm_class_writing_user", this.writing_idx);

            if(me.gubun =='file') {
            
                var wfile = document.querySelector('#writingFile');
                var maxSize = 2 * 1024 * 1024;
                // console.log(wfile.files);
                if (wfile.files.length <= 0) {
                    alert("파일을 선택해주세요.");
                    return false;
                }

             

                // var validChk = ["application/msword",
                //  "application/pdf",
                //  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                //  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                //  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                //  "application/x-hwp", "application/haansofthwp", "application/vnd.hancom.hwp"
                //  ].indexOf( wfile.files[0].type) > -1;

                // if(validChk == false)  {
                //      alert("잘못된 확장자 입니다.");
                //      return false;
                //  }

                 if(wfile.files[0].size > maxSize) {
                     alert("첨부파일 사이즈는 2MB 이내로 등록 가능합니다.");
                     return false;
                 }
               
                formData.append("wfile", wfile.files[0]);
                        
            } else {    

                if(me.writing_content=='') {
                    alert("첨삭게시물을 작성해주세요.");
                    return false;
                }

                formData.append("content", me.writing_content);
            }

                
            this.axios.post(this.$store.state.host + '/rest/writing/modWritingUser', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function (res) {
                if (res.data.err == 0) {
                    alert("제출이 완료되었습니다.");
                    me.showSendWriting = false;
                    location.href="/class?classid="+me.classid;
                    
                }
            });
      
        },
        inputFile:function(el) {
             el.target.previousSibling.previousSibling.click();
        },
        inputName:function(el) {
            this.writing_file_name = el.target.files[0].name
        }
    }
    //   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->


<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400;700&display=swap');

$point-color: #53CAFF;
$purple: #6974FF;
$gray: #B7B7B7;
$border-color: #E9E9E9;
$back-gray: #F5F5F5;

// 결석
$absent: #FF4068;
// 출석
$attend: #53CAFF;
// 휴강
$cancel: #FFB055;
// 예정
$scheduled: #E1E1E1;
// 공결
$reasons: #2FEECD;

.class {
    width: 1200px;
    margin: 0 auto;
    padding-bottom: 60px;

    .floating-write {
        position: fixed;
        right: 0;
        cursor: pointer;
        bottom: 0;
    }

    // .page-top-wrap {
    //     width: 100%;
    //     border-bottom: 10px solid #F5F5F5;

    .top {
        // padding-right: 20px;
        border-bottom: 10px solid #f5f5f5;;
        padding-bottom: 17px;
        padding-top: 70px;
        background: url("../assets/img/top-bg.png") no-repeat right -80px;
        background-size: 300px;
        position: relative;

        .my-reason {
            position: absolute;
            right: 0;
            bottom: 15%;
        }

        p {
            font-size: 14px;
            letter-spacing: 0px;
            color: #000000;
            opacity: 1;
            margin-top: 20px;
        }

        div {
            select {
                border: 1px solid var(--unnamed-color-53caff);
                background: #FFFFFF 0% 0% no-repeat padding-box;
                border: 1px solid #53CAFF;
                border-radius: 4px;
                opacity: 1;
                color: #53CAFF;
                ;
            }
        }
    }

    .wrap {
        width: 100%;
        max-width: 700px;
    }

    // }

    .page-top {
        border-bottom: 1px solid #E9E9E9;

        .review-top {

            div {
                background: #F5F5F5 0% 0% no-repeat padding-box;
                border: 1px solid #E9E9E9;
                border-radius: 10px;
                opacity: 1;
                width: 95%;
                margin: 0 auto;
                box-sizing: border-box;
                padding-top: 19px;
                padding-bottom: 19px;

                p {
                    float: left;
                    text-align: center;

                    &:first-child {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #B7B7B7;
                        opacity: 1;
                    }

                    &:last-child {
                        font-size: 14px;
                        letter-spacing: 0px;
                        color: #000000;
                        opacity: 1;
                    }
                }
            }
        }
    }

    .page-top-wrap-notice {
        width: 90%;
        max-width: 700px;
        padding-bottom: 20px;
        margin: 0 auto;

        .none-notice {
            display: table;
            min-height: 300px;
            width: 100%;

            p {
                display: table-cell;
                vertical-align: middle;
                text-align: center;
                color: var(--unnamed-color-b7b7b7);
                text-align: center;
                font-size: 16px;
                font-weight: bold;
                letter-spacing: 0px;
                color: #B7B7B7;
                opacity: 1;
            }
        }

        .notice-wrap {
            .add-box {
                width: 100%;
                border-bottom: 1px solid #E9E9E9;
                padding-top: 15px;
                padding-bottom: 15px;
                padding-left: 20px;
                padding-right: 20px;
                position: relative;

                select {
                    width: 100%;
                    border: none;
                    font-size: 14px;
                    letter-spacing: 0px;
                    color: #000000;
                    background: white;
                    opacity: 1;
                }

                input[type="text"],
                input[type="password"] {
                    border-radius: 0;
                    border-top: none;
                    border-right: none;
                    border-left: none;
                    border-bottom: none;
                    font-size: 16px;
                    padding: 0 10px;
                    width: 100%;
                }

                .file {
                    position: absolute;
                    right: 0;
                    right: 20px;
                    width: 20px;
                    cursor: pointer;
                }

                a {
                    font-size: 14px;
                    letter-spacing: 0px;
                    color: #53CAFF;
                    opacity: 1;
                }

                textarea {
                    width: 100%;
                    border: none;
                    height: 200px;
                    resize: none;
                    font-size: 16px;
                }
                img{
                    width: 25px;
                }
                img.down-img{
                    width: 14px;
                }
            }
        }
    }
}

.btn {
    width: 100%;
    max-width: 700px;
    margin: 0 auto;
}

.footer {
    position: static;
}

@media only screen and (max-width: 414px) {
    .class {
        width: 100%;

        .top {
            background: url("../assets/img/top-bg.png") no-repeat 160px -80px;
            background-size: 300px;

            &.wrap {
                width: 100%;
                padding-left: 5%;
                max-width: none;
            }
        }

        .page-top-wrap-notice {
            width: 100%;

            .wrap {
                width: 90%;
                max-width: none;
            }
        }
    }

    .btn {
        width: 90%;
    }
}
</style>

